import React from 'react'
import { Footer as FooterCore } from '../Footer'
import { useContext } from './Context'
import { useContext as useParentContext } from '../Context'
import { TabName } from '../TabName'
import isEmpty from 'lodash/isEmpty'
import { jsonTryParse } from '@ztechapps/common.utils'

export const Footer = () => {
  const { activeTemplate } = useContext()
  const { addTask, setNewTasks } = useParentContext()

  const tasks = React.useMemo(() => {
    let _tasks = jsonTryParse(activeTemplate?.value)
    _tasks = isEmpty(_tasks) ? [] : _tasks
    return _tasks
  }, [activeTemplate])
  const disabled = isEmpty(tasks)

  const onSave = async () => {
    setNewTasks(tasks)
    await addTask?.action?.({ tasks, activeTab: TabName.fromTemplate })
  }

  return <FooterCore disabled={disabled} onSave={onSave} isBusy={addTask?.loading} />
}
